export default () => ({
  data() {
    return {
      selectedVersionIndex: -1,
      selectedColorIndex: -1
    }
  },
  filters: {
    formatVersionName(val) {
      return val?.indexOf('@') > 0 ? val.split('@')[1] : val
    }
  },
  computed: {
    isValid() {
      // 只有版本和颜色的时候才支持选择
      let specMainSeqArr = Object.values(this.specItem.specMainSeq)
      if (specMainSeqArr.length === 2 && specMainSeqArr.includes('颜色') && specMainSeqArr.includes('版本')) {
        return true
      } else {
        return false
      }
    },
    versionSpecId() {
      return this.findSpecId('版本')
    },
    colorSpecId() {
      return this.findSpecId('颜色')
    },
    // 版本列表list
    versions() {
      return this.specItem.specItemSeq[this.versionSpecId]
    },
    // 颜色list
    colors() {
      return this.specItem.specItemSeq[this.colorSpecId]
    },
    colorsValid() {
      return this.specItem.specItemSeq[this.colorSpecId].filter(
        (item, index) => this.skuMap[`${this.selectedVersionIndex + 1}-${index + 1}`]
      )
    },
    currVersion() {
      return this.isValid && this.versions[this.selectedVersionIndex]
    },
    currColor() {
      return this.isValid && this.colors[this.selectedColorIndex]
    },
    currSkuId() {
      return this.skuMap[`${this.selectedVersionIndex + 1}-${this.selectedColorIndex + 1}`]
    },
    skuMap() {
      const map = {}
      const { skuSpecList, specMain } = this.specItem
      skuSpecList.forEach(sku => {
        const specItemIds = specMain.map(specId => sku.sequences[specId]).join('-')
        map[specItemIds] = sku.skuId
      })
      let i = 1
      let j = 1
      while (i <= this.versions.length) {
        let arr = []
        Object.keys(map).forEach(item => {
          if (item.split('-')[0] == i) {
            arr.push(map[item])
          }
        })
        map[`${i}-0`] = arr.join(',')
        i++
      }
      while (j <= this.colors.length) {
        let arr = []
        Object.keys(map).forEach(item => {
          if (item.split('-')[1] == j) {
            arr.push(map[item])
          }
        })
        map[`0-${j}`] = arr.join(',')
        j++
      }
      return map
    },
    selectedIndexs() {
      return this.selectedVersionIndex + '-' + this.selectedColorIndex
    }
  },
  watch: {
    // 选择发生了变化，那么重新请求sku
    selectedIndexs() {
      this.skuChange && this.skuChange()
    },
    // 这是数据源
    specItem: {
      handler: function () {
        this.selectedVersionIndex = -1
        this.selectedColorIndex = -1
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeVersionIndex(index) {
      // 不存在的sku禁止选择
      if (this.selectedColorIndex !== -1 && !this.isValidateSku(index, this.selectedColorIndex)) {
        return
      }
      // 如果当前选择与之前选中相同，则取消选择
      if (this.selectedVersionIndex === index) {
        this.selectedVersionIndex = -1
      } else {
        this.selectedVersionIndex = index
      }
    },
    changeColorIndex(index) {
      // 不存在的sku禁止选择
      if (this.selectedVersionIndex !== -1 && !this.isValidateSku(this.selectedVersionIndex, index)) {
        return
      }
      // 如果当前选择与之前选中相同，则取消选择
      if (this.selectedColorIndex === index) {
        this.selectedColorIndex = -1
      } else {
        this.selectedColorIndex = index
      }
    },
    isValidateSku(versionIndex, colorIndex) {
      return this.skuMap[`${versionIndex + 1}-${colorIndex + 1}`]
    },
    clearSelectIndex() {
      this.selectedVersionIndex = -1
      this.selectedColorIndex = -1
    },
    findSpecId(name) {
      const { specMainSeq } = this.specItem
      for (const [key, value] of Object.entries(specMainSeq)) {
        if (value === name) {
          return key
        }
      }
    }
  }
})
